export default __webpack_public_path__ + "static/Rectangle4386-1c2630c7a44e542f3d8c602cc3a31400.png";